import React from 'react';
import { STEP_TYPE } from '../../constants';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';
import { selectAllOrders } from '../../modules/orders/stores/slice';

const StepContent = ({
  step,
  indexStep,
  stepPopover,
  onClickStep,
  widthDuration,
  driverId,
  selectedMultipleSteps,
  multipleStepState,
  selectedStep,
  isLate = false,
  isEarly = false,
}) => {
  const orders = useSelector(selectAllOrders);
  const isMultipleSelected = multipleStepState?.steps?.find(
    (item) => item.stepId === step.stepId && item.type === step.type && driverId === item.driverId,
  );
  const color = step.color;

  const style = {
    borderColor: color,
    color: color,
    width: widthDuration,
    minWidth: 'max-content',
    borderWidth: isMultipleSelected || selectedStep?.id === step.id ? '3px' : '1px',
    zIndex: 10,
  };

  if (Number(indexStep) >= 10) style.letterSpacing = '-1px';

  if (step.status === 'COMPLETED') {
    if (step.type === STEP_TYPE.pickup && step.status === 'COMPLETED') {
      const orderIds = step.orderIds || [];
      const isCompleted = orderIds.some((id) => {
        const order = orders.find((o) => o.id === id);
        return order && order.pickupStatus === 'COLLECTED';
      });
      style.color = 'white';

      if (isCompleted) {
        style.backgroundColor = '#437444';
        style.borderColor = '#437444';
      } else {
        style.backgroundColor = '#b03030';
        style.borderColor = '#b03030';
      }
    } else if (step.type === STEP_TYPE.delivery && step.status === 'COMPLETED') {
      // For delivery, check if any order in orderIds is completed
      const orderIds = step.orderIds || (step.orderId ? [step.orderId] : []);
      const isCompleted = orderIds.some((id) => {
        const order = orders.find((o) => o.id === id);
        return order && order.status === 'COMPLETED';
      });
      style.color = 'white';
      if (isCompleted) {
        style.backgroundColor = '#437444';
        style.borderColor = '#437444';
      } else {
        style.backgroundColor = '#b03030';
        style.borderColor = '#b03030';
      }
    }
  }

  // Time window violation styling
  if (step.status !== 'COMPLETED' && (isLate || isEarly)) {
    style.borderColor = isLate ? '#d32f2f' : '#ed6c02';
    style.backgroundColor = isLate ? '#ffebee' : '#fff3e0';
    style.color = isLate ? '#d32f2f' : '#ed6c02';
  }

  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey || e.shiftKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, driverId);
    } else {
      onClickStep(step);
    }
  };
  return (
    <div
      className={`${step.type.toLowerCase() === 'pickup' ? 'unit' : 'unit unit2'} ${stepPopover}`}
      style={style}
      onClick={(e) => newClickStep(e, step)}
    >
      {step.index}
      {(isLate || isEarly) && step.status !== 'COMPLETED' && (
        <span className="anticon">
          <ReactSVG src={`${process.env.PUBLIC_URL || ''}/icons/late.svg`} />
        </span>
      )}
    </div>
  );
};

export default StepContent;
